import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  State,
  County,
  City,
  Zipcode,
  CountiesAndCitiesData,
} from '../../models/address';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  private apiBaseUrl = environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getStates(search?: string): Observable<State[]> {
    let params = new HttpParams();

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<State[]>(`${this.apiBaseUrl}/api/states`, { params });
  }

  getCounties(stateId: number, search?: string): Observable<County[]> {
    let params = new HttpParams();

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<County[]>(
      `${this.apiBaseUrl}/api/states/${stateId}/counties`,
      { params },
    );
  }

  getCities(countyId: number, search?: string): Observable<City[]> {
    let params = new HttpParams();

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<City[]>(
      `${this.apiBaseUrl}/api/states/${countyId}/cities`,
      { params },
    );
  }

  getZipcodes(cityId: number, search?: string): Observable<Zipcode[]> {
    let params = new HttpParams();

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<Zipcode[]>(
      `${this.apiBaseUrl}/api/cities/${cityId}/zipcodes`,
      { params },
    );
  }

  getCitiesAndCountiesByStateIds(
    stateIds: number[] | string[],
  ): Observable<CountiesAndCitiesData> {
    return this.http.post<CountiesAndCitiesData>(
      `${this.apiBaseUrl}/api/cities_and_counties`,
      { state_ids: stateIds },
    );
  }

  getZipcodesByCityIds(cityIds: number[] | string[]): Observable<Zipcode[]> {
    return this.http.post<Zipcode[]>(`${this.apiBaseUrl}/api/zipcodes`, {
      city_ids: cityIds,
    });
  }
}
